import React, { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import ChatWidget from '../ChatWidget';
import { ProfileNudgeProvider } from '../../components/ProfileNudgeProvider';
import { usePageView } from '../../hooks/usePageView';
import { useScrollToTop } from '../../hooks/useScrollToTop';

const styles = {
  wrapper: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    padding: '24px',
    background: '#f5f5f5',
  },
};

function Layout() {
  usePageView();
  const contentRef = useRef(null);
  useScrollToTop(contentRef);
  return (
    <ProfileNudgeProvider>
    <div style={styles.wrapper}>
      <Sidebar />
      <div style={styles.main}>
        <TopBar />
        <main style={styles.content} ref={contentRef}>
          <Outlet />
        </main>
        <ChatWidget />
      </div>
    </div>
    </ProfileNudgeProvider>
  );
}

export default Layout;
